
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Fourzeroseater() {



    const cardData =
    {
        keyword: '40 Seater Bharat Benz Bus Hire Pune',
        heading: 'Amruta Travels: 40 Seater Bharat Benz Bus Hire Pune',
        headingDescription: 'Amruta Travels offers 40 Seater BharatBenz Bus Hire in Pune, providing the perfect balance of space, comfort, and performance for medium to large group travel. Whether you’re organizing a corporate trip, family function, school outing, or pilgrimage, our 40-seater BharatBenz buses ensure a smooth and enjoyable journey. Equipped with comfortable seating, air-conditioned interiors, and ample luggage capacity, these buses are driven by experienced professionals committed to safety and punctuality. With affordable pricing and 24/7 booking support, Amruta Travels guarantees a reliable and luxurious travel solution across Pune.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

    "services": [
    {
      "name": "40 Seater Bharat Benz AC Bus Rental Pune",
      "description": "Rent a 40 Seater Bharat Benz AC bus in Pune for a comfortable and luxurious group travel experience. Whether for corporate events, weddings, school trips, or family tours, our buses are equipped with air conditioning, spacious seating, and modern amenities to ensure a pleasant journey."
    },
    {
      "name": "Bharat Benz 40 Seater Bus Hire for Events",
      "description": "For all your events in Pune, hire a 40 Seater Bharat Benz bus. Our buses provide comfortable transport for guests, employees, or attendees, ensuring everyone travels in comfort and arrives in style. Perfect for conferences, meetings, or large gatherings."
    },
    {
      "name": "40 Seater Bharat Benz Bus for School Trips",
      "description": "Ensure a safe and comfortable journey for school children with our 40 Seater Bharat Benz buses. With spacious seating, air conditioning, and reliable drivers, these buses are perfect for school picnics, educational trips, and excursions."
    },
    {
      "name": "Wedding Transport 40 Seater Bharat Benz",
      "description": "Make your wedding day even more special with our 40 Seater Bharat Benz bus. Ideal for transporting guests to and from the wedding venue, our buses provide comfort, luxury, and punctuality, making your event even more memorable."
    },
    {
      "name": "Corporate Office Bus 40 Seater Hire",
      "description": "Looking for corporate transport? Our 40 Seater Bharat Benz buses offer a perfect solution for team outings, business meetings, and office events. Enjoy a smooth and comfortable ride, ensuring your team travels in style and comfort."
    },
    {
      "name": "Bharat Benz Bus for Group Travel Pune",
      "description": "Our 40 Seater Bharat Benz buses are perfect for group travel in Pune. Whether it's a family reunion, friends’ gathering, or any group outing, our buses provide ample space, comfortable seating, and air conditioning for a relaxed journey."
    },
    {
      "name": "40 Seater Bus Booking in Hadapsar Pune",
      "description": "Book a 40 Seater Bharat Benz bus in Hadapsar for your group travel needs. Perfect for events, school trips, and corporate travel, our buses offer comfort, luxury, and a hassle-free travel experience."
    },
    {
      "name": "AC Bus Hire 40 Seater PCMC",
      "description": "Rent a 40 Seater AC bus in PCMC for corporate events, weddings, or family trips. Our Bharat Benz buses provide luxurious amenities, including air conditioning and comfortable seating, making them an excellent choice for any group outing."
    },
    {
      "name": "40 Seater Bharat Benz Bus for Outstation",
      "description": "Travel to outstation destinations in luxury with our 40 Seater Bharat Benz buses. Whether it's a religious tour, family vacation, or corporate trip, our buses offer comfort, safety, and ample space for all your needs."
    },
    {
      "name": "Pune to Shirdi 40 Seater Bus Bharat Benz",
      "description": "Take a spiritual journey to Shirdi in a 40 Seater Bharat Benz bus. With spacious seats, air conditioning, and a reliable driver, this bus ensures your religious tour is comfortable and stress-free."
    },
    {
      "name": "Religious Tour Bus 40 Seater Pune",
      "description": "Our 40 Seater Bharat Benz buses are the ideal choice for religious tours from Pune. Visit various pilgrimage destinations in comfort and style with air-conditioned buses, ensuring a relaxing and safe travel experience."
    },
    {
      "name": "Bharat Benz Bus Rental in Kothrud Pune",
      "description": "Rent a 40 Seater Bharat Benz bus in Kothrud for your next group trip. With luxurious amenities and a professional driver, our buses provide a premium travel experience for all types of events and tours."
    },
    {
      "name": "Affordable 40 Seater Bus Rental in Pune",
      "description": "Get the best value for your money with our affordable 40 Seater Bharat Benz bus rental services in Pune. Enjoy luxury and comfort at competitive rates for all types of group travel, from weddings to corporate events."
    },
    {
      "name": "Bharat Benz Event Coach Hire Pune",
      "description": "Our 40 Seater Bharat Benz buses are perfect for any event in Pune. Whether it’s a corporate function, wedding, or large group gathering, our event coach hire ensures your guests travel in luxury and comfort."
    },
    {
      "name": "40 Seater Luxury Bus Bharat Benz",
      "description": "For those looking for a high-end travel experience, our 40 Seater luxury Bharat Benz buses offer comfort, style, and modern amenities. Perfect for weddings, corporate events, and long-distance travel, these buses provide the ultimate travel experience."
    }
  ],
  "tableData": [
    ["40 Seater Bharat Benz AC Bus Rental Pune", "Bharat Benz 40 Seater Bus Hire for Events"],
    ["40 Seater Bharat Benz Bus for School Trips", "Wedding Transport 40 Seater Bharat Benz"],
    ["Corporate Office Bus 40 Seater Hire", "Bharat Benz Bus for Group Travel Pune"],
    ["40 Seater Bus Booking in Hadapsar Pune", "AC Bus Hire 40 Seater PCMC"],
    ["40 Seater Bharat Benz Bus for Outstation", "Pune to Shirdi 40 Seater Bus Bharat Benz"],
    ["Religious Tour Bus 40 Seater Pune", "Bharat Benz Bus Rental in Kothrud Pune"],
    ["Affordable 40 Seater Bus Rental in Pune", "Bharat Benz Event Coach Hire Pune"],
    ["40 Seater Luxury Bus Bharat Benz"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "40 Seater Bharat Benz Bus on Hire in Pune",
    "WhyChoosedescription": "Amruta Travels offers the luxurious 40 Seater Bharat Benz buses for hire in Pune, designed for medium to large group travel. Whether it's a corporate event, family trip, or a wedding, our Bharat Benz buses provide the ultimate comfort, style, and reliability for your journey."
  },
  {
    "WhyChooseheading": "Spacious, Comfortable, and Air-Conditioned Travel",
    "WhyChoosedescription": "Our 40 Seater Bharat Benz buses are equipped with advanced air-conditioning, spacious reclining seats, and plenty of legroom. Perfect for both short and long trips, these buses ensure your group travels in utmost comfort and relaxation."
  },
  {
    "WhyChooseheading": "Premium Amenities for an Unmatched Experience",
    "WhyChoosedescription": "The 40 Seater Bharat Benz buses come with luxurious features such as well-cushioned seats, wide windows for scenic views, ambient lighting, and modern entertainment systems, ensuring a luxurious and enjoyable journey for all passengers."
  },
  {
    "WhyChooseheading": "Affordable, Transparent, and Inclusive Pricing",
    "WhyChoosedescription": "We provide clear and transparent pricing for 40 Seater Bharat Benz bus rentals. Our rates are all-inclusive, covering fuel, tolls, driver charges, taxes, and more—so you can plan your trip budget without any hidden costs or surprises."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
    "WhyChoosedescription": "Our drivers are highly trained, licensed, and well-versed in navigating Pune’s local routes as well as popular outstation destinations. They ensure a smooth and timely journey while maintaining the highest standards of safety and professionalism."
  },
  {
    "WhyChooseheading": "Perfect for Corporate Outings, Family Trips, and Weddings",
    "WhyChoosedescription": "The 40 Seater Bharat Benz bus is ideal for corporate outings, family gatherings, school trips, wedding guest transport, and group tours. Its blend of comfort, capacity, and reliability makes it the perfect choice for any large group event."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for a Safe and Smooth Journey",
    "WhyChoosedescription": "Our fleet of 40 Seater Bharat Benz buses is meticulously maintained and regularly inspected to ensure safety and optimal performance. We prioritize the well-being of our passengers, ensuring a smooth, stress-free ride every time."
  },
  {
    "WhyChooseheading": "Easy Booking Process and 24/7 Customer Support",
    "WhyChoosedescription": "Booking a 40 Seater Bharat Benz bus with Amruta Travels is simple and convenient. You can book online, via phone, or in person at our office. Our 24/7 customer support team is available to assist with any bookings, queries, or special requests you may have."
  }
]



















    }

const faqData = [
  {
    question: 'Can I rent a 40-seater Bharat Benz bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 40-seater Bharat Benz buses for rent in Pune. These buses are perfect for medium-sized groups and are ideal for corporate events, family trips, school tours, and long-distance travel.',
  },
  {
    question: 'What amenities are available in the 40-seater Bharat Benz bus?',
    answer: 'Our 40-seater Bharat Benz buses are equipped with premium amenities, including comfortable seating, air conditioning, entertainment systems, ample legroom, overhead storage, spacious luggage compartments, and a clean, well-maintained interior.',
  },
  {
    question: 'Is the 40-seater Bharat Benz bus available for both local and outstation travel?',
    answer: 'Yes, the 40-seater Bharat Benz bus is available for local city travel in Pune as well as outstation trips to destinations like Lonavala, Mahabaleshwar, Shirdi, Mumbai, and other popular tourist spots.',
  },
  {
    question: 'Is a driver included in the 40-seater Bharat Benz bus rental?',
    answer: 'Yes, all 40-seater Bharat Benz bus rentals from Amruta Travels come with a professional, licensed driver who ensures a safe, comfortable, and timely journey for all passengers.',
  },
  {
    question: 'How much does it cost to rent a 40-seater Bharat Benz bus in Pune?',
    answer: 'Rental charges for the 40-seater Bharat Benz bus vary based on factors such as distance, trip duration, and services required. Typically, rates start from ₹50-₹65 per km. For an accurate quote, contact us with your travel details.',
  },
  {
    question: 'Is the 40-seater Bharat Benz bus comfortable for long journeys?',
    answer: 'Yes, the 40-seater Bharat Benz bus is designed to provide a comfortable travel experience for long journeys, with ample space, air conditioning, and plush seating for a relaxed and enjoyable trip.',
  },
  {
    question: 'Are the 40-seater Bharat Benz buses well-maintained and sanitized?',
    answer: 'Absolutely. All our 40-seater Bharat Benz buses are regularly maintained, thoroughly cleaned, and sanitized before each trip to ensure passenger safety and hygiene.',
  },
  {
    question: 'How do I book a 40-seater Bharat Benz bus in Pune?',
    answer: 'Booking a 40-seater Bharat Benz bus is simple! You can easily book online via our website or by contacting our customer support team. We offer fast booking assistance and competitive pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Harish Patil',
    role: 'Corporate Executive, Pune',
    text: 'We hired a 40-seater Bharat Benz bus from Amruta Travels for a team-building event. The bus was comfortable, spacious, and well-maintained. The service was excellent, and we had a great experience.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Meena Joshi',
    role: 'Family Trip Organizer',
    text: 'I booked a 40-seater Bharat Benz bus for a family trip to Mahabaleshwar. The bus was very comfortable, the air conditioning worked perfectly, and the journey was smooth. Highly recommend Amruta Travels for any group travel.',
    rating: 5,
  },
];





























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "40 Seater Bharat Benz Bus Hire in Pune",
  "image": "https://bushireinpune.com/assets/images/40-seater-bharat-benz-bus.jpg",
  "description": "Hire a 40 Seater Bharat Benz AC Bus in Pune for school trips, corporate office travel, weddings, religious tours, and outstation journeys like Pune to Shirdi. Amruta Travels offers luxury and affordable group transport services in Hadapsar, Kothrud, PCMC, and across Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5900",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/40-seater-bharat-benz-bus-hire-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | 40 Seater Bharat Benz Bus Hire in Pune | AC Coach for Weddings & School Trips</title>
  <meta 
    name="description" 
    content="Book a 40 seater Bharat Benz AC bus in Pune for school excursions, corporate events, group travel, and outstation trips to Shirdi and beyond. Reliable and affordable luxury buses by Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/87.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Fourzeroseater;